import { DialogActions } from "@material-ui/core";
import { useState } from "react";
import TabsErp from "../../../../../components/tabs/TabsErp";
import { ClientesBodyContextProvider } from "../../contexts/ClientesBodyContext";
import useClientesBodyController from "../../controllers/ClientesBodyController";
import { CustomButton, CustomDialogContent } from "../../styles/styles";

const View = ({ setOpen, setLoading }) => {
  const { tabTitles, tabContents, handleSaveClientParams } =
    useClientesBodyController(setLoading, setOpen);

  const [tabIndex, setTabIndex] = useState(0);

  return (
    <>
      <CustomDialogContent>
        <TabsErp
          headers={tabTitles}
          tabIndex={tabIndex}
          children={tabContents}
          onChange={(event, value) => {
            if (Number.isInteger(value)) setTabIndex(value);
          }}
        />
      </CustomDialogContent>
      <DialogActions>
        <CustomButton
          onClick={handleSaveClientParams}
          label="Salvar"
          bgcolor="primary"
          hovercolor="tertiary"
        />
      </DialogActions>
    </>
  );
};

const ClienteBody = ({ ...props }) => (
  <ClientesBodyContextProvider>
    <View {...props} />
  </ClientesBodyContextProvider>
);
export default ClienteBody;
